// The active guide has to survive route changes and a page refresh (a guide
// like "create a Website inbox" spans several routes), so it is kept in
// sessionStorage. Every read and write is guarded: storage can be missing or
// throw in private windows or when site data is blocked, and the guide must
// then simply not resume rather than break the page.
const STORAGE_KEY = 'onboarding_guide_session';

export const readGuideSession = () => {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (
      !parsed ||
      typeof parsed.guideId !== 'string' ||
      !Number.isInteger(parsed.stepIndex) ||
      parsed.stepIndex < 0
    ) {
      return null;
    }
    return {
      guideId: parsed.guideId,
      stepIndex: parsed.stepIndex,
      accountId: parsed.accountId ?? null,
    };
  } catch {
    return null;
  }
};

export const writeGuideSession = ({ guideId, stepIndex, accountId }) => {
  try {
    window.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ guideId, stepIndex, accountId })
    );
  } catch {
    // Storage unavailable: the guide just won't resume after a refresh.
  }
};

export const clearGuideSession = () => {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clear.
  }
};
